<template>
  <div class="vehicle-info-container">
    <div class="info-card">
      <div class="card-header">
        <van-icon name="logistics" size="18" />
        <span>绑定车辆信息</span>
      </div>
      <div class="card-content">
        <div class="info-item">
          <div class="item-label">
            <van-icon name="guide-o" class="icon" />
            <span>车头号</span>
          </div>
          <div class="item-value">{{chetouhao}}</div>
        </div>
        <div class="info-item">
          <div class="item-label">
            <van-icon name="cluster-o" class="icon" />
            <span>车挂号</span>
          </div>
          <div class="item-value">{{cheguahao}}</div>
        </div>
      </div>


      <div class="card-footer">
        <van-notice-bar
            left-icon="info-o"
            wrapable
            :scrollable="false"
            text="如需修改车头或车挂信息，请先至我的页面选择车头或车挂信息管理进行修改"
            style="width: 95%"
        />
        <van-button 
          round 
          type="danger" 
          size="small" 
          @click="confirmUnbind" 
          class="unbind-button"
        >
          <van-icon name="close" /> 解除绑定
        </van-button>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/fetch/api.js";
import { Dialog,Toast } from "vant";
export default{
  props:{
    chetouhao: {
      type: String,
      default: ""
    },
    cheguahao: {
      type: String,
      default: ""
    },
  },
  methods:{
    confirmUnbind() {
      var that = this;
      Dialog.confirm({
          title: '重新绑定车辆',
          message: '是否确认重新绑定车辆',
        })
        .then(() => {
          // on confirm
          var chetouhao = that.chetouhao;
          var cheguahao = that.cheguahao;
          var openid = this.$store.state.wx_info.openid;

          api.updateBindVehicle(openid, chetouhao, cheguahao).then(function(resData) {
            var res = JSON.parse(resData);
            if (res.respCode == 0) {
              that.$emit('cancelBind');
              Toast.fail('解绑成功');
            } else {
              Toast.fail(res.message);
            }
          }).catch(function(error) {
            console.log('error',error);
          });


        })
        .catch(() => {
          // on cancel
        });
    },
  }
}
</script>
<style lang="scss" scoped>
.vehicle-info-container {
  padding: 12px;
  background-color: #f7f8fa;
}

.info-card {
  background-color: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  
  .card-header {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #f5f6f7;
    
    .van-icon {
      color: #4080ff;
      margin-right: 8px;
    }
    
    span {
      font-size: 16px;
      font-weight: 500;
      color: #323233;
    }
  }
  
  .card-content {
    padding: 16px;
    
    .info-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;
      border-bottom: 1px solid #f5f6f7;
      
      &:last-child {
        border-bottom: none;
      }
      
      .item-label {
        display: flex;
        align-items: center;
        color: #969799;
        font-size: 14px;
        
        .icon {
          color: #4080ff;
          margin-right: 6px;
          font-size: 18px;
        }
      }
      
      .item-value {
        font-size: 16px;
        font-weight: 500;
        color: #323233;
      }
    }
  }
  
  .card-footer {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    padding: 16px;
    border-top: 1px solid #f5f6f7;

    
    .unbind-button {
      width: 50%;
      font-size: 14px;
      
      .van-icon {
        margin-right: 4px;
        font-size: 14px;
      }
    }
  }
}
</style>
